import { Injectable } from "@angular/core";
import { GlobalConstants } from "src/app/constants";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import * as moment from "moment";
import { PrintFolders, PrintFoldersAdapter } from "../Model/print-folders";

@Injectable({
  providedIn: "root",
})
export class PrintQueueService {
  private baseURL =
    GlobalConstants.BASE_API_URL + ":" + GlobalConstants.BASE_API_URL_PORT;
  private API_NAME = "printQueue";

  constructor(
    private httpClient: HttpClient,
    private adapter: PrintFoldersAdapter
  ) {}

  getInitialFolders(): Observable<PrintFolders[]> {
    const url = `${this.baseURL}/${this.API_NAME}/api/get/initial/folders`;
    return this.httpClient.get(url).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map((item) => this.adapter.adapt(item)))
    );
  }

  getByFolder(numberDays, path): Observable<PrintFolders[]> {
    const url = `${this.baseURL}/${this.API_NAME}/api/get/by/folder`;
    const params = new HttpParams()
      .set("numberDays", numberDays)
      .set("path", path);
    return this.httpClient.get(url, { params }).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map((item) => this.adapter.adapt(item)))
    );
  }

  getB2BDocs(): Observable<PrintFolders[]> {
    const url = `${this.baseURL}/${this.API_NAME}/api/get/b2b/docs`;
    return this.httpClient.get(url).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map((item) => this.adapter.adapt(item)))
    );
  }
}
